import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration from your Flutter app
const firebaseConfig = {
  apiKey: 'AIzaSyDyhO-kzJSm3o3-KVmMJifbe0sunhPGY6o', // Using Android key for web
  authDomain: 'allez-hopp.firebaseapp.com',
  projectId: 'allez-hopp',
  storageBucket: 'allez-hopp.firebasestorage.app',
  messagingSenderId: '434131253461',
  appId: '1:434131253461:android:9528eed39e0e6b3cb74a5c', // Using Android app ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app;
